import Logo from "../items/Logo"
import LinkItem from "../items/LinkItem"
import AppContext from "../../context/AppContext"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { useState, useContext } from "react"

function Header() {
    const { blur } = useContext(AppContext)
    const [menuState, setMenuState] = useState('')
    const mover = useNavigate()
    const { pathname } = useLocation()
    const authPaths = ['/login', '/trynow', '/signup', '/forgot_password', '/verify', '/reset_password']

    const openMenu = () => {
        setMenuState('responsive')
    }

    const closeMenu = () => {
        setMenuState('')
    }

    window.addEventListener('click', (e) => {
        const parentElement = e.target.parentElement;

        if(parentElement && (parentElement.classList.contains('links') || e.target.parentElement.classList.contains('action-btns'))){
            closeMenu()
        }
    })

  return (
    <nav className={`${blur ? 'blur' : ''} ${menuState}`}>
        <div className="close-menu" onClick={() => closeMenu()}>
            <i className="fa-solid fa-xmark"></i>
        </div>
        <div>
            <p>+234 0000 0000 000, +234 0901 0000 000</p>
        </div>
        <div>
            <Link to={authPaths.includes(pathname) ? -1 : '/'} className="logo">
                {authPaths.includes(pathname) ? <div>Back</div> : <Logo/>}
            </Link>
            <div className="links-btns">
                <div className="links">
                    <LinkItem to_page='/' link_name='Home' />
                    <LinkItem to_page='/about' link_name='About' />
                    <LinkItem to_page='/blog' link_name='Blog' />
                    <LinkItem to_page='/team' link_name='Team' />
                </div>
                <div className="action-btns">
                    <button className="login" onClick={() => {mover("/login")}}>Log in</button>
                    <button className="trynow" onClick={() => {mover("/trynow")}}>Try now</button>
                </div>
            </div>
            <div className="reponsive_nav" onClick={() => openMenu()}>
                <i className="fa-solid fa-bars"></i>
            </div>
        </div>
    </nav>
  )
}

export default Header